import React from "react";
import team_one from "../../assets/team/team_one.png";
import team_two from "../../assets/team/team_two.png";
import team_three from "../../assets/team/team_threee.png";
import team_four from "../../assets/team/team_four.png";

const team_data = [
  {
    name: "Stephen Kowal",
    desc: "As the Chief Executive Officer, Stephen is accountable for overall leadership and direction. Since joining GogiBus in 2019 he has rapidly grown the business organically and via strategic acquisitions. Stephen has extensive executive management experience across IT software and services, including an ANZ sales director position for a US multi-national IT company and several CIO roles locally and overseas.",
    img: team_one,
    desig: "Chief Executive Officer",
  },
  {
    name: "David Dekker",
    desc: "David’s responsibilities are wide-ranging across operations, IT, and sales and marketing. He has been instrumental in the mergers and acquisitions space, end-to-end IPO processes and corporate governance for GogiBus. David’s previous experience includes managing sales and business units at various organisations, including SAP locally and overseas, and most recently he was the CEO of Cubic Consulting, a company owned by GogiBus. ",
    img: team_two,
    desig: "Chief Operations Officer",
  },
  {
    name: "Julia Merten",
    desc: "Julia leads the HR team and has a focus on strategies and policies that promote sustainable people growth at GogiBus. A hands-on leader and coach, Julia works closely with other GogiBus leaders and the HR talent team to attract and retain the best people. Julia has extensive experience in the IT industry, having previously worked for organisations like Accenture, DA Consulting and Cubic Consulting. ",
    img: team_three,
    desig: "Chief People Officer",
  },
  {
    name: "Helen Ord",
    desc: "Working closely with key stakeholders at GogiBus to support business initiatives and manage legal risk, Helen provides sound technical advice by combining her market experience with commercial acumen. An experienced corporate lawyer, previous roles include Head of Legal at BPAY and Bank of Queensland, and seven years as a Partner at Dentons.",
    img: team_four,
    desig: "General Counsel",
  },
];

const Team = () => {
  return (
    <div
      id="team"
      className="flex flex-col my-[50px] px-4 md:px-0 gap-10 items-center justify-center w-full md:w-[85%] mx-auto"
    >
      <div className="text-center relative">
        <h1 className="text-[#451644] dark:text-light font-extrabold text-[50px] font-serif">
          A Skilled Team
        </h1>
        <div
          className="dark:bg-custom-gradient"
          style={{
            position: "absolute",
            width: "320px",
            height: "157.05px",
            left: "50%", // Center horizontally
            top: "50%", // Center vertically
            transform: "translate(-50%, -50%) matrix(1, 0, -0.03, 1, 0, 0)", // Adjust for precise positioning
            opacity: 0.2,
            filter: "blur(34px)",
            borderRadius: "50%",
            zIndex: "0", // Ensure it's behind the text
          }}
        ></div>
      </div>

      <p className="text-sm sm:text-lg dark:text-dimWhite font-bold text-center w-full lg:w-[60%]">
        With a background across a multitude of industries and organisations,
        our people bring the technical and business experience required to
        successfully lead your technological evolution.
      </p>

      <div className="grid mt-10 grid-cols-1 sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 gap-5">
        {team_data.map((team, index) => (
          <div
            className="flex min-h-[340px] flex-col items-center sm:items-start justify-start gap-3"
            key={index}
          >
            <img
              src={team.img}
              className="w-[210px] shadow-lg duration-300 hover:scale-110 cursor-pointer rounded-lg h-[260px]"
              alt=""
            />
            <h3 className="text-lg dark:text-light text-[#451644] font-bold font-sans">
              {team.name}
            </h3>
            <div className="h-[1px] w-[80%] dark:bg-light  text-[#451644] bg-[#451644]   "></div>
            <p className="text-lg  dark:text-dimWhite text-[#451644] font-bold font-sans">
              {team.desig}
            </p>

            <p className="text-sm font-light w-[80%] dark:text-white ">
              {team.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
